import { render, staticRenderFns } from "./DOT.vue?vue&type=template&id=366de203&scoped=true"
import script from "./DOT.vue?vue&type=script&lang=js"
export * from "./DOT.vue?vue&type=script&lang=js"
import style0 from "./DOT.vue?vue&type=style&index=0&id=366de203&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366de203",
  null
  
)

export default component.exports